module.exports = __webpack_public_path__ + "static/media/gd.d3251b80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/work/gd.jpg
// module id = 49
// module chunks = 0